import PropTypes from "prop-types";
import noop from "lodash/noop";
import { MembersSpaceOptions } from "@/react/components/Spaces/Header/SpaceHeaderTitleDropdown/spaceOptions/MembersSpaceOptions";
import { useSpaceHeaderTitleDropdown } from "@/react/components/Spaces/Header/SpaceHeaderTitleDropdown/useSpaceHeaderTitleDropdown";
import {
  canManageSpace,
  isBasicPostsSpace,
  isChatSpace,
  isCourseSpace,
  isEventsSpace,
  isImagesSpace,
  isMembersSpace,
} from "@/react/helpers/spaceHelpers";
import { Loader } from "@circle-react-uikit/Loader";
import {
  ChatSpaceOptions,
  CourseSpaceOptions,
  EventSpaceOptions,
  PostSpaceOptions,
} from "./spaceOptions";

export const SpaceHeaderTitleDropdownFullScreen = ({
  space,
  isAdmin,
  isMember,
  onInviteMember = noop,
  onAddCoverImage = noop,
}) => {
  const { isLoadingSpaceMember } = useSpaceHeaderTitleDropdown({ space });
  const isSpaceCourseSpace = isCourseSpace(space);
  const isSpaceEventSpace = isEventsSpace(space);
  const isSpacePostSpace = isBasicPostsSpace(space);
  const isSpaceChatSpace = isChatSpace(space);
  const isSpaceMembersSpace = isMembersSpace(space);
  const isSpaceImagesSpace = isImagesSpace(space);
  const canMemberManageSpace = canManageSpace(space);

  if (isLoadingSpaceMember) {
    return <Loader />;
  }

  if (isSpacePostSpace || isSpaceImagesSpace)
    return (
      <PostSpaceOptions
        space={space}
        isAdmin={isAdmin}
        canMemberManageSpace={canMemberManageSpace}
        isMember={isMember}
        onInviteMember={onInviteMember}
        onAddCoverImage={onAddCoverImage}
      />
    );

  if (isSpaceEventSpace)
    return (
      <EventSpaceOptions
        space={space}
        isAdmin={isAdmin}
        canMemberManageSpace={canMemberManageSpace}
        isMember={isMember}
        onInviteMember={onInviteMember}
        onAddCoverImage={onAddCoverImage}
      />
    );

  if (isSpaceChatSpace)
    return (
      <ChatSpaceOptions
        space={space}
        isAdmin={isAdmin}
        canMemberManageSpace={canMemberManageSpace}
        isMember={isMember}
        onInviteMember={onInviteMember}
      />
    );

  if (isSpaceCourseSpace)
    return (
      <CourseSpaceOptions
        space={space}
        isAdmin={isAdmin}
        canMemberManageSpace={canMemberManageSpace}
        isMember={isMember}
        onInviteMember={onInviteMember}
      />
    );

  if (isSpaceMembersSpace)
    return (
      <MembersSpaceOptions
        space={space}
        isAdmin={isAdmin}
        canMemberManageSpace={canMemberManageSpace}
        isMember={isMember}
        onInviteMember={onInviteMember}
        onAddCoverImage={undefined}
      />
    );

  return null;
};

SpaceHeaderTitleDropdownFullScreen.propTypes = {
  space: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  isMember: PropTypes.bool,
  onAddCoverImage: PropTypes.func,
  onInviteMember: PropTypes.func,
};
